import axiosIns from '../../../xaxios';
import { obtenerUrlAPIComisiones } from '../utils/funciones';

export default {
  async findAllNombres(opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIComisiones('plan-cobros-programa/nombres'), opciones);
  },
};
